import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Footer() {
  const guideArticles = articles.slice(0, 6);

  return (
    <footer className="w-full bg-secondary-500 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <h3 className="font-heading font-semibold text-lg mb-4">
              Oopbuy Spreadsheet Guide
            </h3>
            <p className="text-white/75 text-sm leading-relaxed mb-4">
              Der umfassendste deutsche Guide f&uuml;r Oopbuy Spreadsheet. Finde gepr&uuml;fte Produkte,
              Verk&auml;ufer und Kategorien.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/15 text-white text-sm font-medium hover:bg-white/25 transition-all duration-300"
            >
              <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
              Zur Hauptseite
            </a>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-white/90">Kategorien</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-white/65 text-sm hover:text-white transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-white/90">Mehr Kategorien</h4>
            <ul className="space-y-2.5">
              {categories.slice(7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-white/65 text-sm hover:text-white transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-white/90">SEO Guides</h4>
            <ul className="space-y-2.5">
              {guideArticles.map((article) => (
                <li key={article.slug}>
                  <Link
                    to={`/artikel/${article.slug}`}
                    className="text-white/65 text-sm hover:text-white transition-colors"
                  >
                    {article.category}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/"
                  className="text-white/50 text-xs hover:text-white/80 transition-colors"
                >
                  Alle Guides ansehen →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/15 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-xs">
            &copy; {new Date().getFullYear()} Oopbuy Spreadsheet Guide. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/"
              className="text-white/50 text-xs hover:text-white/80 transition-colors"
            >
              Startseite
            </Link>
            <Link
              to="/artikel/oopbuy-spreadsheet-guide"
              className="text-white/50 text-xs hover:text-white/80 transition-colors"
            >
              Kompletter Guide
            </Link>
            <Link
              to="/artikel/sicherheitsguide"
              className="text-white/50 text-xs hover:text-white/80 transition-colors"
            >
              Sicherheit
            </Link>
            <Link
              to="/artikel/versandguide"
              className="text-white/50 text-xs hover:text-white/80 transition-colors"
            >
              Versand
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-white/50 text-xs hover:text-white/80 transition-colors"
            >
              Hauptseite
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}